import React from 'react'

export const Cart = () => {
  return (
    <div>Cart</div>
  )
}
